/**
 * Les dernières séries reçues d'un produit, ouvertes à la demande depuis la
 * fiche (Philippe, 07/10/2026) : la tendance d'une livraison à l'autre — on
 * vend tout, on jette un tiers, la marge tient ou fond.
 */
import { useEffect, useState } from 'react';
import api from '../../services/api';
import BilanSeriePrecedente, { ResumeSerie } from './BilanSeriePrecedente';

interface Props {
  product: { id: string; name: string };
  onClose: () => void;
}

export default function BilanSeriesModal({ product, onClose }: Props) {
  const [series, setSeries] = useState<ResumeSerie[] | null>(null);
  const [erreur, setErreur] = useState<string | null>(null);

  useEffect(() => {
    let actif = true;
    api
      .get<ResumeSerie[]>(`/pos/restock-alerts/series/${product.id}?nb=3`)
      .then((r) => actif && setSeries(r))
      .catch((e) => actif && setErreur(e?.message || 'Bilan indisponible'));
    return () => {
      actif = false;
    };
  }, [product.id]);

  return (
    <div className="fixed inset-0 z-[70] bg-black/40 flex items-center justify-center p-4" onClick={onClose}>
      <div
        className="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 px-5 py-4 border-b">
          <div>
            <h3 className="text-lg font-bold text-gray-900">📊 Bilan des séries</h3>
            <p className="text-sm text-gray-600">{product.name}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="px-3 py-1.5 text-sm font-semibold rounded-lg border border-gray-300 active:bg-gray-100"
          >
            Fermer
          </button>
        </div>
        <div className="overflow-y-auto px-5 py-4 space-y-3">
          {erreur && <p className="text-sm text-red-700">{erreur}</p>}
          {!erreur && series === null && <p className="text-sm text-gray-500">Chargement…</p>}
          {series && series.length === 0 && (
            <p className="text-sm text-gray-600">Aucune réception enregistrée pour ce produit.</p>
          )}
          {series?.map((s, i) => (
            <BilanSeriePrecedente
              key={s.recue_le}
              serie={s}
              titre={i === 0 ? 'Dernière série' : i === 1 ? 'Série d’avant' : 'Il y a trois séries'}
            />
          ))}
          {series && series.length > 0 && (
            <p className="text-xs text-gray-500 pt-1">
              Une série = ce qui a été reçu le même jour. Marges hors TVA ; pertes et prélèvements comptés au
              prix d’achat. Les prélèvements (famille, repas, échantillons) ne sont pas des pertes.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
